// Cabinets (measuring points) defined before a sensor is installed: tenant
// app records (app "coldchain", kind "cabinet") on the store's label value
// (subject site = <store value>), body {account_id, name, type, regime}.
// A sensor installed with the same store + cabinet name is that cabinet.
import { tenantApi } from "../lib/account";

export interface Cabinet { id: string; site: string; name: string; type: string; regime: string; account_id: string; version: number }

export async function loadCabinets(): Promise<Cabinet[]> {
  const r = await tenantApi<{ items: { id: string; subject_value?: string; version: number; body: { account_id?: string; name?: string; type?: string; regime?: string } }[] }>("GET", "/records?app=coldchain&kind=cabinet&limit=500");
  return r.items.map((x) => ({ id: x.id, site: x.subject_value || "", name: x.body.name || "", type: x.body.type || "", regime: x.body.regime || "", account_id: x.body.account_id || "", version: x.version }));
}

export function addCabinet(c: { site: string; account_id: string; name: string; type: string; regime: string }) {
  return tenantApi("POST", "/records", {
    app: "coldchain", kind: "cabinet", subject_key: "site", subject_value: c.site, status: "active",
    title: c.name, body: { account_id: c.account_id, name: c.name.trim(), type: c.type, regime: c.regime },
  });
}

export function removeCabinet(c: Cabinet) {
  return tenantApi("DELETE", `/records/${c.id}?version=${c.version}`);
}
